import React, {useState} from 'react';
import {Grid} from "./components/Grid";
import {animation} from "./stores/AnimationStore";
import {observer} from "mobx-react-lite";
import {MidiSupportWarning} from "./components/MidiSupportWarning";
import {MidiPortsSelect} from "./components/MidiPortsSelect";
import {Formulas} from "./components/Formulas";
import {Linn} from "./stores/LinnStore";
import {grid} from "./stores/GridStore";
import {Colors} from "./components/Colors";
import {Instructions} from "./components/Instructions";
import {Rates} from "./components/Rates";
import {LINN128, LINN200} from "./model";
import './App.css';
import {ColorsSelector} from "./components/ColorsSelector";

const App = observer(() => {

    const changeModel = (e: any) => {
        // console.log("changeModel", e.target.value);
        const m = parseInt(e.target.value, 10);
        if (isNaN(m)) {
            console.error("invalid model", e.target.value);
        } else {
            grid.setModel(m);
        }
    }

    const [showInstructions, setInstructions] = useState(false);

    return (
        <div>
            <MidiSupportWarning />
            <div className="header bottom">
                <div className="about">
                    <div><span className="bold">AnimaLinn </span>{process.env.REACT_APP_VERSION}</div>
                    <div>by&nbsp;<a href="https://studiocode.dev" target="_blank" rel="noopener noreferrer">StudioCode.dev</a></div>
                </div>
                <div className="text-center ml20">
                    <div>
                        {!showInstructions && <button onClick={() => setInstructions(true)}>Show instructions</button>}
                        {showInstructions && <button onClick={() => setInstructions(false)}>Hide instructions</button>}
                    </div>
                </div>
            </div>
            <main>
                {showInstructions && <Instructions />}
                <div className="f bg border-t border-b">
                    <MidiPortsSelect/>
                    <button onClick={Linn.enableUserMode}>Enable LinnStrument user mode</button>
                    <div onChange={changeModel}>
                        <label><input type="radio" value={LINN128} defaultChecked={grid.model===LINN128} name="linn-model" /> Linn-128</label>
                        <label><input type="radio" value={LINN200} defaultChecked={grid.model===LINN200} name="linn-model" /> Linn-200</label>
                    </div>
                </div>
                <div className="f mt20">
                    <Grid />
                    <Colors />
                </div>
                <div className="mt10 center">
                    <div className="f center">
                        {!animation.running && <button type="button" className="transport" onClick={animation.play}>PLAY</button>}
                        {animation.running && <button type="button" className="transport" onClick={animation.stop}>STOP</button>}
                        {/*{animation.running ? "running"  : "stopped"}*/}
                        <div className="ml20">
                            time: {(animation.timestamp / 1000).toFixed(0)}
                        </div>
                        <div className="ml20">
                            min: {animation.minV.toFixed(2)}
                        </div>
                        <div className="ml20">
                            max: {animation.maxV.toFixed(2)}
                        </div>
                    </div>
                    <Rates />
                    <ColorsSelector />
                </div>
                <div className="f mt20 center">
                    <input type="text" className="formula"
                           value={animation.instructions} onChange={e => animation.updateFormula(e.target.value)} />
                </div>
                <Formulas/>
            </main>
            <div className="footer">
                <div>An experiment inspired by <a href="https://tixy.land/" target="_blank" rel="noreferrer noopener">tixy.land</a></div>
                <div className="bold">For experimental use only.</div>
            </div>
        </div>
    );
});

export default App;
